module.exports = __webpack_public_path__ + "img/stripe.ee23682a.png";